import FileKeyLoader from '@whitecobalt/tungsten/esm/components/FileKeyLoader'
import Icon from '@whitecobalt/tungsten/esm/components/Icon'
import Image from '@whitecobalt/tungsten/esm/components/Image'
import Lazyload from '@whitecobalt/tungsten/esm/components/Lazyload'
import React, { memo, useMemo } from 'react'
import { Link } from 'react-router-dom'
import './index.scss'

interface ProductThumbnailProps {
    productName: string;
    fileKey?: string;
    url: string;
}

const ProductThumbnail: React.FunctionComponent<ProductThumbnailProps> = memo(({productName, fileKey, url}) => {
    const payload = useMemo(() => ({
        "maxWidthInPX": 175,
        "maxHeightInPX": 175,
    }), [])

    return (
        <Link className="product-thumbnail" to={url}>
            <h4 className="product-thumbnail-title">{productName}</h4>
            <Lazyload className="product-img-container">
                {fileKey ? 
                    fileKey.startsWith('http') ? (
                        <Image
                            src={fileKey}
                            alt="halspan coming soon"
                            fallbackSrc="/images/coming-soon.png"
                        />
                    ) 
                    : ( 
                        <FileKeyLoader 
                            fileKey={fileKey}
                            endpoint="/api/FileImage"
                            payload={payload}
                            fallbackSrc="/images/coming-soon.png"
                            cache
                            cacheUniqueString="175px"
                        />
                    ) : (
                        <img
                            src="/images/coming-soon.png"
                            alt="halspan coming soon"
                        />
                    )}
            </Lazyload>
        </Link>
    )
})

export default ProductThumbnail
